import { createContext, useContext, useEffect } from "react";
import { SELF_HOSTED_FONT_FAMILIES, getGoogleFontsStylesheetUrl, resolveFontFamilies } from "../utils/fontCatalog";

export const FontStylesContext = createContext(null);

// Shared font faces are local; only the rest of the editor catalog needs a stylesheet.
export default function FontStyles({ families }) {
  const additional = resolveFontFamilies(families).filter(name => !SELF_HOSTED_FONT_FAMILIES.includes(name));
  const serverFonts = useContext(FontStylesContext);
  additional.forEach(name => serverFonts?.add(name));
  const fontKey = additional.join("|");

  useEffect(() => {
    if (!fontKey) return;
    const existing = new Set(Array.from(document.querySelectorAll("link[data-app-fonts]"))
      .flatMap(link => link.getAttribute("data-app-fonts").split("|")));
    const missing = fontKey.split("|").filter(name => !existing.has(name));
    if (!missing.length) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = getGoogleFontsStylesheetUrl(missing);
    link.setAttribute("data-app-fonts", missing.join("|"));
    document.head.appendChild(link);
    // Keep the bounded catalog cached across route changes to avoid font swaps.
  }, [fontKey]);
  return null;
}
